import { useTranslation } from "react-i18next";

const GroupInfoSection = ({ groupInfo }) => {
  const { t } = useTranslation();
  return (
    <div className="lg:w-1/2 ">
      <img
        src={groupInfo.groupAvatar}
        alt="group avatar"
        className="rounded-lg w-full bg-defaultGreen"
      />
      <div>
        <p className="font-bold text-xl my-4 capitalize">
          {groupInfo.groupName}
        </p>
        <div className="border border-[#DEE2E7] dark:border-[#3D404B] rounded-md p-3 flex flex-col gap-3 my-4">
          <p>
            <span className="font-bold">{t("contribution-page.target")}: </span>
            <span>{groupInfo.targetAmount.toLocaleString()}</span> RWF
          </p>
          <div className="w-full mb-2 bg-[#E8F3ED] rounded-lg h-3">
            <div
              className="bg-defaultGreen h-3 rounded-lg"
              style={{
                width: `${
                  groupInfo.percentageRaised > 100
                    ? 100
                    : groupInfo.percentageRaised
                }%`,
              }}
            ></div>
          </div>
          <p>
            <span className="font-bold">{t("contribution-page.raised")}: </span>
            <span>{groupInfo.raisedAmount.toLocaleString()}</span> RWF
          </p>
          <div className="flex flex-col md:flex-row gap-3 justify-between">
            <p>
              <span className="font-bold">
                {t("contribution-page.target-date")}:{" "}
              </span>
              <span>{groupInfo.targeDate}</span>
            </p>
            <p>
              <span className="font-bold">{groupInfo.timeRemaining}</span>{" "}
              Month(s) Remaining
            </p>
          </div>
        </div>
        {/* group description */}
        <div>{groupInfo.description}</div>
        {/* suppport details  */}
        <p className="my-4">
          <span className="font-bold">{t("contribution-page.support")}: </span>
          +250787496316
        </p>
      </div>
    </div>
  );
};

export default GroupInfoSection;
